import React from 'react';
import FormStyle1 from '../Form/FormStyle1';
import ImageGrid from '../ImageGrid/ImageGrid';
import { Helmet } from 'react-helmet-async';

const GestlifeStickyLayout = () => {
  return (
        <>
         <Helmet>
           <title>Gestacion subrogada es nuestra vida - Gestlife</title>
           <meta name="description" content="Informacion sobre nosotros, la gestacion subrogada es nuestra vida." />
         </Helmet>
    <div style={styles.container}>
      <div style={styles.contentWrapper}>
        {/* Contenido principal a la izquierda */}
        <div style={styles.mainContent}>
          <h1 style={styles.mainHeading}>
            Hacemos posible lo imposible
          </h1>

          <h2 style={styles.subHeading}>
            Información sobre nosotros
          </h2>

          <div style={styles.textBlock}>
            <p style={styles.highlightedParagraph}>
              La gestación subrogada es nuestra vida
            </p>

            <p style={styles.paragraph}>
              Nuestra misión es clara: hacer que hagas realidad tu sueño de tener hijos. Algo a lo que nadie debiera tener que renunciar si no es por convicción propia. No lo vamos a intentar. Lo vamos a conseguir y tendrás tu bebé, pase lo que pase.
            </p>
            <p style={styles.paragraph}>
              Gestlife es una empresa perteneciente al grupo estadounidense Invest Medical LLC que tiene como misión el asesoramiento jurídico y médico con la finalidad de facilitar el objetivo de la paternidad a ciertos padres que por distintos motivos no han tenido la oportunidad de conseguirlo hasta el momento. Somos la única agencia europea, con 18 oficinas propias en 11 países, y más de 190 empleados.
            </p> 
            <p style={styles.paragraph}>
              Nuestro código ético es un decálogo de valores no excluyentes que guían nuestra actividad profesional y la relación con nuestros clientes, colaboradores y con la sociedad en su conjunto.
            </p>
            <p style={styles.paragraph}>
              Que cada mañana veas la cara sonriente de tu bebé que da un nuevo sentido a tu vida y la llena de color e ilusión de nuevo por vivir, es nuestro leitmotiv.
            </p>
            <p style={styles.paragraph}>
              Somos grandes, porque con las cosas importantes no se juega. Tu proceso de gestación subrogada es nuestro compromiso.
            </p>
            <p style={styles.paragraph}>
              Los servicios Gestlife, los más premiados del sector.
            </p>

            {/* La cuadrícula de imágenes aquí */}
            <ImageGrid /> 

            <p style={styles.paragraph}>
              Gestlife ha sido premiada con Medalla de Oro Europea al Mérito en el Trabajo, otorgados por el presidente de la Asociación Europea de Economía y Competitividad, entre otros premios recibidos en los últimos años.
            </p>
            <p style={styles.paragraph}>
              Gestlife ha sido premiada la entrega de los premios MEDALLA DE ORO EUROPEA AL MÉRITO EN EL TRABAJO, otorgados por el presidente de La Asociación Europea de Economía y Competitividad, que impuso al representante de la compañía la Medalla de Oro europea al mérito al trabajo, en especial reconocimiento a la larga trayectoria del grupo en la defensa de los derechos civiles, reconocido como "pionero y prestigioso despacho multidisciplinar de abogados" por la Asociación.
            </p> 
            <p style={styles.paragraph}>
              La Asociación Europea de Economía y Competitividad nació con el objetivo de promover, desarrollar y reconocer los mecanismos de las empresas que fomentan un buen desarrollo empresarial dentro del marco europeo y la conciencia del emprendedor y del buen hacer. La Asociación Europea de Economía y Competitividad Está dirigida por su Presidente José Luis Barceló (editor y presidente del diario El Mundo Financiero), y cuenta entre sus Consejeros, a reputados miembros de la sociedad civil como Enrique Cerezo Torres (Empresario y Presidente del Atlético de Madrid), Kike Sarasola (empresario y fundador de Room Mates Hotels, el Profesor José María Gay de Liébana (Doctor en ciencias económicas y derecho, y Catedrático de la Universidad de Barcelona, o el Profesor Juan José Enríquez Barbé, Decano del Colegio de economistas de Valencia.
            </p>
            <p style={styles.paragraph}>
              Este es el quinto premio recibido por los servicios jurídicos de GESTLIFE en menos de un año. El año pasado los servicios jurídicos de la compañía recibieron la ESTRELLA DE ORO, otorgada por el INSTITUTO PARA LA EXCELENCIA PROFESIONAL, en reconocimiento a su labor profesional y compromiso con la excelencia.
            </p>
            <p style={styles.paragraph}>
              Gestlife está avalada por La Asociación Padres Por la Gestación Subrogada
            </p>
            <p style={styles.paragraph}>
              Los servicios Gestlife, los más premiados del sector.
            </p>
            <p style={styles.paragraph}>
              Una asociación independiente, que aglutina a más de 700 padres que lo han sido gracias a la gestación, y que fiscaliza las agencias, para garantizar las buenas prácticas, avalando con su sello solo a aquellas que reúnen los parámetros que exigen.
            </p>
            <p style={styles.paragraph}>
              Más de 180 empleados dedicados exclusivamente a hacer realidad tu sueño de tener un bebe.
            </p>
            <p style={styles.paragraph}>
              Para los procesos de gestación subrogada tenemos un precio adaptado a tus necesidades con planes de financiación en caso de que lo necesites. Infórmate gratuitamente de todo lo que podemos hacer por ti en materia de maternidad subrogada.
            </p>
            <h3 style={styles.subHeadingMinor}>
              Gestlife está avalada por La Asociación Padres Por la Gestación 
            </h3>
            <p style={styles.paragraph}>
              una asociación independiente, que aglutina a más de 500 padres que lo han sido gracias a la gestación subrogada en España, y que fiscaliza las agencias, para garantizar las buenas prácticas, avalando con su sello solo a aquellas que reúnen los parámetros que exigen. 
            </p>
          </div>
        </div>

        {/* Formulario a la derecha, sin envoltorio extra ni sticky */}
        <div style={styles.formColumn}>
          <FormStyle1 />
        </div>
      </div>
    </div>
     </>
  );
};

export default GestlifeStickyLayout;

// --- Estilos para la versión de escritorio ---
const styles = {
  container: {
    backgroundColor: 'white',
    padding: '2rem',
    paddingTop: '3rem',
    paddingBottom: '3rem',
    fontFamily: 'Arial, sans-serif', 
    paddingLeft: '4rem',
    paddingRight: '4rem',
  },
  contentWrapper: {
    display: 'grid',
    gridTemplateColumns: '1fr', // Por defecto, una columna para móviles
    gap: '4rem', 
    maxWidth: '1200px', 
    margin: '0 auto', 
    // La media query para desktop se simula con JS debajo
    // Idealmente, esto iría en CSS externo o con una librería CSS-in-JS.
    '@media (min-width: 1024px)': { 
      gridTemplateColumns: '2fr 1fr', 
    },
  },
  mainContent: {
    marginBottom: '2rem', // Mantener espacio para móviles/tablets
    '@media (min-width: 1024px)': {
      marginBottom: '0', // Eliminar el margen si hay dos columnas
    },
  },
  mainHeading: {
    fontSize: '2.8rem', 
    fontWeight: 'bold',
    color: '#ec4899', 
    lineHeight: '1.2',
    marginBottom: '1.5rem', 
  },
  subHeading: {
    fontSize: '1.8rem', 
    fontWeight: '700', 
    color: '#f472b6', 
    marginTop: '2.5rem', 
    marginBottom: '1.5rem', 
    borderBottom: '2px solid #f9a8d4', 
    paddingBottom: '0.5rem',
  },
  subHeadingMinor: { 
    fontSize: '1.3rem', 
    fontWeight: '600', 
    color: '#f472b6', 
    marginTop: '2rem',
    marginBottom: '1rem',
  },
  textBlock: {
    color: '#4b5563',
    lineHeight: '1.7', 
    fontSize: '1.05rem', 
    marginTop: '1.5rem',
  },
  paragraph: {
    marginBottom: '1rem', 
  },
  highlightedParagraph: {
    fontWeight: '700', 
    color: '#1f2937', 
    textDecoration: 'underline',
    textDecorationColor: '#f9a8d4', 
    marginBottom: '1.2rem', 
    fontSize: '1.1rem', 
  },
  formColumn: {
    // Ya no necesita position: 'relative' si el formulario no es sticky
    // El formulario FormStyle1 controlará sus propios estilos internos
  },
  // Eliminamos el objeto stickyForm, ya no es necesario
};
